import { state, props } from 'cerebral/tags'
import { when, push, set, splice, unset } from 'cerebral/operators'
import setDeletedAtForSelectedFiles from '../factories/setDeletedAtForSelectedFiles'
import createSnackbar from 'modules/App/factories/createSnackbar'
import getCurrentMediaId from '../actions/getCurrentMediaId'
import setCurrentDetailedFile from './setCurrentDetailedFile'

export default [
  getCurrentMediaId,
  push(state`media.filesToDelete`, props`id`),
  splice(state`media.selectedFiles`, props`viewIndex`, 1),
  unset(state`media.files.${props`id`}`),
  setDeletedAtForSelectedFiles(true),
  unset(state`media.currentFile`),
  when(state`media.selectedFiles`, files => files.length === 0),
  {
    true: [
      set(state`media.tags.form`, {}),
      set(state`media.showDetail`, false)
    ],
    false: [set(props`nextIndex`, 0), ...setCurrentDetailedFile]
  },
  createSnackbar({ key: 'bms.media.deletedFiles', params: { count: 1 } }),
  set(state`media.filesToDelete`, [])
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/onDeleteFileInDetailedView.js